import { render, staticRenderFns } from "./HKBanksForm.vue?vue&type=template&id=60a5e57a&scoped=true&"
import script from "./HKBanksForm.vue?vue&type=script&lang=js&"
export * from "./HKBanksForm.vue?vue&type=script&lang=js&"
import style0 from "./HKBanksForm.vue?vue&type=style&index=0&id=60a5e57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a5e57a",
  null
  
)

export default component.exports